/**
 * IconSize — system-wide icon scale.
 *
 * Tailwind classes alone can't size Phosphor SVGs (they use their own `size`
 * prop), so we expose constants. Two tiers only:
 *   sm = 16px — default for buttons, inline labels, table actions
 *   lg = 24px — primary CTAs, dashboard tile glyphs, hero buttons
 *
 * Anything else is a one-off and should be re-evaluated.
 */
export const ICON_SIZE = {
    sm: 16,
    lg: 24,
};

/** Get a Phosphor `size` prop value from a system size key. */
export function iconSize(key) {
    return ICON_SIZE[key] ?? ICON_SIZE.sm;
}
